import { render, staticRenderFns } from "./Seatsio.vue?vue&type=template&id=02275bb4&"
import script from "./Seatsio.vue?vue&type=script&lang=js&"
export * from "./Seatsio.vue?vue&type=script&lang=js&"
import style0 from "./Seatsio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports